import { useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'
import { authApi, firmApi } from '@/services/api'

export function useAuth() {
  const store = useAuthStore()
  const { user, firms, currentFirm, isAuthenticated, isLoading, setUser, setFirms, setCurrentFirm, setLoading, logout } = store

  useEffect(() => {
    if (isAuthenticated && !user) {
      loadUser()
    } else if (!isAuthenticated) {
      setLoading(false)
    }
  }, [isAuthenticated, user])

  async function loadUser() {
    try {
      setLoading(true)
      const res = await authApi.me()
      setUser(res.data)
      const firmRes = await firmApi.list()
      const firmList = firmRes.data.organizations || []
      setFirms(firmList)
      // Restore or pick first firm
      const savedFirmId = localStorage.getItem('current_firm_id')
      const saved = firmList.find((f: { id: string }) => f.id === savedFirmId)
      setCurrentFirm(saved || firmList[0] || null)
    } catch {
      logout()
    } finally {
      setLoading(false)
    }
  }

  async function createFirm(name: string) {
    const res = await firmApi.create({ name })
    const firm = res.data
    setFirms([...firms, firm])
    setCurrentFirm(firm)
    return firm
  }

  return { user, firms, currentFirm, isAuthenticated, isLoading, setCurrentFirm, logout, loadUser, createFirm }
}
